import { useEffect, useState } from "react";

/**
 * Debounce a value by a given delay (ms).
 * Returns the debounced value, which only updates after the input value has stopped changing for the delay period.
 */
export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
